import React from 'react';
import { FaGlobe } from 'react-icons/fa';
import { useApp } from '../../context/AppContext';
import './settings.css';

const Settings = () => {
    const { language, toggleLanguage } = useApp();

    return (
        <div className="settings-container">
            {/* Language Switcher */}
            <button 
                className="settings-btn language-btn" 
                onClick={toggleLanguage}
                aria-label="Change Language"
                title={`Current: ${language.toUpperCase()}`}
            >
                <FaGlobe className="settings-icon" />
                <span className="settings-text">{language.toUpperCase()}</span>
            </button>
        </div>
    );
};

export default Settings;
